import type { DrillThrough } from '@chukua/common';
import { reportTabPath } from '../reports.paths';

/**
 * Where a figure's number comes from: the records tab of its report under the figure's own filters. The API built
 * `drillThrough.filters` from the figure's `where`, so the records' count and sum are the figure's.
 */
export function drillLink({ reportKey, filters }: DrillThrough): string {
  const params = new URLSearchParams();
  for (const [name, value] of Object.entries(filters)) {
    if (value === undefined) continue;
    for (const item of [value].flat()) params.append(name, item);
  }
  return reportTabPath(reportKey, 'records', params.toString());
}
